<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title>Detalle del {{'Movimiento' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content style="margin-bottom: 0%;">

    <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label class="text-style" *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label class="text-style" *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="canView && !isSearching && item != null">

      <!--DATOS GENERALES-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;">

        <mat-expansion-panel-header>
          <mat-panel-title class="title">
            Datos de Movimiento
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="formGroup">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Fecha de Movimiento*</mat-label>
                <input matInput [matDatepicker]="fechaMovimientoPicker" formControlName="FechaMovimiento"  (click)="fechaMovimientoPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaMovimientoPicker">
                </mat-datepicker-toggle>
                <mat-datepicker #fechaMovimientoPicker></mat-datepicker>
                <mat-error *ngIf="!formGroup.controls['FechaMovimiento'].valid && formGroup.controls['FechaMovimiento'].touched">
                  {{ getErrorFechaMovimiento() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Fecha Movimiento</b>: {{item?.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoMovimientoId">
                  <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['TipoMovimientoId'].valid && formGroup.controls['TipoMovimientoId'].touched">
                  {{ getErrorTipoMovimientoId() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Tipo de Movimiento</b>: {{item?.TipoMovimientoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Detalle*</mat-label>
                <input matInput formControlName="Detalle" maxlength="100" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formGroup.controls['Detalle'].valid && formGroup.controls['Detalle'].touched">
                  {{ getErrorDetalle() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Detalle</b>: {{item?.Detalle}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                <mat-select formControlName="Moneda">
                  <mat-option *ngFor="let s of monedaList" [value]="s">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['Moneda'].valid && formGroup.controls['Moneda'].touched">
                  {{ getErrorMonedaId() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Moneda</b>: {{item?.Moneda}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Importe*</mat-label>
                <input matInput type="number" formControlName="MontoBase" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formGroup.controls['MontoBase'].valid && formGroup.controls['MontoBase'].touched">
                  {{ getErrorMontoBase() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Importe Base</b>: {{item?.MontoBase | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <!-- Alicuota IVA -->
            <ng-container *ngIf="!(item?.TipoMovimientoSigno > 0) && !isRosbaco">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">

                <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                  <mat-label *ngIf="!isAlicuotaIvaSearching">IVA*</mat-label>
                  <mat-label *ngIf="isAlicuotaIvaSearching">Cargando...</mat-label>
                  <mat-select formControlName="AlicuotaIvaId" (selectionChange)="onAlicuotaIvaSelect()">
                    <mat-option *ngFor="let s of alicuotaIvaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!formGroup.controls['AlicuotaIvaId'].valid && formGroup.controls['AlicuotaIvaId'].touched">
                    {{ getErrorAlicuotaIvaId() }}
                  </mat-error>
                </mat-form-field>

                <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Alicuota IVA</b>: {{item?.AlicuotaIva}}</mat-label>
                  </div>
                </mat-expansion-panel>

              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style"><b>Importe IVA</b>: {{montoIva | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </ng-container>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Importe Percepciones/Retenciones*</mat-label>
                <input matInput type="number" formControlName="MontoPercepciones" (change)="calcularMontos()" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formGroup.controls['MontoPercepciones'].valid && formGroup.controls['MontoPercepciones'].touched">
                  {{ getErrorMontoPercepciones() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Importe Percepciones/Retenciones</b>: {{item?.MontoPercepciones | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Importe Total</b>: {{montoTotal | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(item?.TipoMovimientoSigno > 0)">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Medio de Pago</b>: {{item?.MedioPagoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!(item?.TipoMovimientoSigno > 0) && !isRosbaco">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Pendiente de Pago</b>: {{item?.Saldo * (item?.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(item?.TipoMovimientoSigno > 0 && item?.Saldo > 0 && !isRosbaco)">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Saldo Sobrante</b>: {{item?.Saldo * (item?.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canChangeState">
                <mat-label *ngIf="!isEstadoSearching">Estado*</mat-label>
                <mat-label *ngIf="isEstadoSearching">Cargando...</mat-label>
                <mat-select formControlName="EstadoId">
                  <mat-option *ngFor="let s of estadoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!formGroup.controls['EstadoId'].valid && formGroup.controls['EstadoId'].touched">
                  {{ getErrorEstadoId() }}
                </mat-error>
              </mat-form-field>
              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canChangeState" [ngStyle]="{ 'background-color': getEstadoBackgroundColor() }">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Estado</b>: {{item?.Estado}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.FechaConfirmacion != null">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Fecha Confirmación</b>: {{item?.FechaConfirmacion | date:'dd/MM/yyyy HH:mm:ss'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.UsuarioConfirmacion != null && item?.UsuarioConfirmacion.length > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Usuario Confirmación</b>: {{item?.UsuarioConfirmacion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.FechaCancelacion != null">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Fecha Cancelación</b>: {{item?.FechaCancelacion | date:'dd/MM/yyyy HH:mm:ss'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.UsuarioCancelacion != null && item?.UsuarioCancelacion.length > 0">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Usuario Cancelación</b>: {{item?.UsuarioCancelacion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="!isRosbaco">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Cuota</b>: {{item?.Cuota}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="(item?.TipoMovimientoSigno > 0)">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit && !isRosbaco">
                <mat-label>Nro. Comprobante</mat-label>
                <input matInput formControlName="NroComprobante" maxlength="100" (keyup.enter)="onGuardar()">
                <mat-error *ngIf="!formGroup.controls['NroComprobante'].valid && formGroup.controls['NroComprobante'].touched">
                  {{ getErroNroComprobante() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Nro. Comprobante</b>: {{item?.NroComprobante}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item?.TipoMovimientoSigno < 0 || (item?.TipoMovimientoSigno > 0 && esEstadoPendiente())">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label>Fecha Vencimiento*</mat-label>
                <input matInput [matDatepicker]="fechaVencimientoPicker" formControlName="FechaVencimiento"  (click)="fechaVencimientoPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                </mat-datepicker-toggle>
                <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                <mat-error *ngIf="!formGroup.controls['FechaVencimiento'].valid && formGroup.controls['FechaVencimiento'].touched">
                  {{ getErrorFechaVencimiento() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Fecha Vencimiento</b>: {{item?.FechaVencimiento | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
                <mat-label class="text-style">Observación</mat-label>
                <textarea matInput formControlName="Observacion" maxlength="300"></textarea>
                <mat-error *ngIf="!formGroup.controls['Observacion'].valid && formGroup.controls['Observacion'].touched">
                  {{ getErrorObservacion() }}
                </mat-error>
              </mat-form-field>

              <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Observación</b>: {{item?.Observacion}}</mat-label>
                </div>
              </mat-expansion-panel>

            </div>

            <ng-container *ngIf="!(item?.TipoMovimientoSigno > 0) && !isRosbaco">

              <ng-container *ngIf="canEdit">

                <hr style="margin: 10px 0px; width: 100%;">

                <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 20px;">
                  <mat-checkbox formControlName="EsRecurrente" (keyup.enter)="onGuardar()" color="primary">¿Es un movimiento recurrente?</mat-checkbox>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="formGroup?.get('EsRecurrente')?.value == true">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Periodicidad de Recurrencia (días)*</mat-label>
                    <input matInput type="number" formControlName="PeriodicidadRecurrencia" (keyup.enter)="onGuardar()" maxlength="10">
                    <!-- <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                      {{ getErrorNombre() }}
                    </mat-error> -->
                  </mat-form-field>
                </div>

              </ng-container>

              <ng-container *ngIf="!canEdit">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Es Recurrente</b>: {{item.EsRecurrente ? 'Sí' : 'No'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="item.EsRecurrente">
                  <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Periodicidad de Recurrencia (días)</b>: {{item.PeriodicidadRecurrencia | number: '1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </ng-container>

            </ng-container>

          </div>

        </form>

      </mat-expansion-panel>

      <!--ADJUNTOS EDIT-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="item?.Adjuntos != null && item?.Adjuntos.length > 0">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <!-- <mat-icon style="margin-top: -3px;">attach_file</mat-icon>  -->
            Adjuntos
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngFor="let file of item.Adjuntos" style="margin: 5px;">

          <div fxFlex=30 fxFlex.xs=100 class="flex-item">

            <mat-form-field appearance="outline" style="width: 100%" *ngIf="canEdit">
              <mat-label>Descripción</mat-label>
              <input matInput [(ngModel)]="file.Descripcion" maxlength="150">
            </mat-form-field>

            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!canEdit">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-style"><b>Descripción</b>: {{file.Descripcion}}</mat-label>
              </div>
            </mat-expansion-panel>

          </div>
          <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="margin-top: 20px;">
            <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
          </div>
          <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;" *ngIf="canEdit">
            <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
              <i class="fa fa-trash fa-1x"></i>
            </button>
          </div>

        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="canEdit">

          <div fxFlex=30 fxFlex.xs=100 class="flex-item">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Descripción</mat-label>
              <input matInput [(ngModel)]="newFileDescripcion">
            </mat-form-field>
          </div>
          <div fxFlex=70 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
            <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
              <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
            </button>
            <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file">
            <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
            </mat-label>
          </div>

        </div>

      </mat-expansion-panel>

      <!--GASTO-->
      <mat-expansion-panel [expanded]="false" style="margin-bottom: 1%;" *ngIf="(item?.GastoId > 0 && itemGasto != null)">

        <mat-expansion-panel-header>
          <mat-panel-title class="title"> {{'Gasto' | translate}} Asociado
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              Datos del {{'Gasto' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="isGastoSearching">
            <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isGastoSearching">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Gasto</b>: {{itemGasto?.FechaGasto | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo</b>: {{itemGasto?.TipoGasto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Servicio</b>: {{itemGasto?.ServicioGastoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Detalle</b>: {{itemGasto?.Detalle}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{itemGasto?.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{itemGasto?.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Moneda</b>: {{itemGasto?.MonedaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Vencimiento</b>: {{itemGasto?.FechaVencimiento | date: 'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe</b>: {{itemGasto?.Importe | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Segundo Vencimiento</b>: {{itemGasto?.FechaVencimiento2 | date: 'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Importe Segundo Vencimiento</b>: {{itemGasto?.Importe2 | number: '1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>IVA</b>: {{itemGasto?.AlicuotaIvaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Proveedor</b>: {{itemGasto?.ProveedorNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <ng-container *ngIf="itemGasto?.ComunidadId != null && itemGasto?.ComunidadId > 0">

          <br />

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de {{'Comunidad' | translate}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="isGastoComunidadSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isGastoComunidadSearching">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Nombre</b>: {{itemGastoComunidad?.Nombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo</b>: {{itemGastoComunidad?.TipoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Cant. Pisos</b>: {{itemGastoComunidad?.CantidadPisos}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Consorcio</b>: {{itemGastoComunidad?.ConsorcioNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Dirección</b>: {{itemGastoComunidad?.Direccion}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="itemGasto?.UnidadFuncionalId != null && itemGasto?.UnidadFuncionalId > 0">

          <br />

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de {{'UnidadFuncional' | translate}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="isGastoUfSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isGastoUfSearching">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Código</b>: {{itemGastoUf?.Codigo}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Número</b>: {{itemGastoUf?.Numero}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>{{'Comunidad' | translate}}</b>: {{itemGastoUf?.Comunidad}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>{{'Consorcio' | translate}}</b>: {{itemGastoUf?.Consorcio}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo Unidad</b>: {{itemGastoUf?.TipoUnidadNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Ambientes</b>: {{itemGastoUf?.CantidadAmbientes}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

      </mat-expansion-panel>

      <!--PEDIDO ITEM-->
      <mat-expansion-panel [expanded]="false" style="margin-bottom: 1%;" *ngIf="(item?.PedidoItemId > 0 && itemPedido != null)">

        <mat-expansion-panel-header>
          <mat-panel-title class="title"> Pedido Asociado
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              Datos del Pedido
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="isPedidoItemsSearching">
            <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isPedidoItemsSearching">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b># Pedido</b>: {{itemPedido?.PedidoId}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Proveedor</b>: {{itemPedido?.ProveedorNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Material</b>: {{itemPedido?.MaterialNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Detalle</b>: {{itemPedido?.Detalle}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Cantidad</b>: {{itemPedido?.Cantidad | number:'1.2-2'}} {{itemPedido?.MaterialUnidadMedida}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Necesidad</b>: {{itemPedido?.FechaNecesidad | date:'dd/MM/yyyy' }}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Moneda</b>: {{itemPedido?.MonedaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Monto</b>: {{itemPedido?.Monto | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{itemPedido?.Observacion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

      </mat-expansion-panel>

      <!--CONTRATO-->
      <mat-expansion-panel [expanded]="false" style="margin-bottom: 1%;" *ngIf="(item?.ContratoId > 0 && itemContrato != null)">

        <mat-expansion-panel-header>
          <mat-panel-title class="title"> {{'Contrato' | translate}} Asociado
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <!--DATOS CONTRATO-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              Datos del {{'Contrato' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="isContratoSearching">
            <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
          </div>

          <div fxLayout="row stretch" class="zb-readonly" *ngIf="!isContratoSearching">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código</b>: {{itemContrato.Codigo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo</b>: {{itemContrato.TipoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Inicio</b>: {{itemContrato.FechaInicio | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Fin</b>: {{itemContrato.FechaFin | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{'Comunidad' | translate}}</b>: {{itemContrato.Comunidad}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Moneda</b>: {{itemContrato.Moneda}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Valor</b>: {{itemContrato.Valor | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>IVA</b>: {{itemContrato.AlicuotaIva}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Monto IVA</b>: {{itemContrato.AlicuotaIvaValor | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Importe Total</b>: {{itemContrato.Valor | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{itemContrato.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br/>

        <!-- UFs -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">home</mat-icon> {{'UnidadFuncional' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <ejs-grid #gridContratoUf [dataSource]='itemContrato.UnidadesFuncionales' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
              <e-columns>
                <e-column field='UnidadFuncionalCodigo' headerText='Código' width=90></e-column>
                <e-column field='UnidadFuncionalNumero' headerText='Número' width=50></e-column>
                <e-column field='UnidadFuncionalTipoUnidad' headerText='Tipo' width=110></e-column>
                <e-column field='UnidadFuncionalCantidadAmbientes' headerText='Ambientes' width=50></e-column>
                <e-column field='UnidadFuncionalNroPiso' headerText='Piso' width=50></e-column>
                <e-column field='UnidadFuncionalComunidad' headerText='Comunidad' width=120>
                  <ng-template #headerTemplate let-data>
                    {{'Comunidad' | translate}}
                  </ng-template>
                </e-column>
                <e-column field='UnidadFuncionalConsorcio' headerText='Consorcio' width=120 *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                  <ng-template #headerTemplate let-data>
                    {{'Consorcio' | translate}}
                  </ng-template>
                </e-column>
                <e-column field='Importe' headerText='Importe' width=70></e-column>
              </e-columns>
              <ng-template #rowTemplate let-data>
                <tr class="e-row">
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCodigo}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNumero}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalTipoUnidad}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCantidadAmbientes}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNroPiso}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalComunidad}}</td>
                  <td class="e-rowcell" style="text-align: center;" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">{{data.UnidadFuncionalConsorcio}}</td>
                  <td class="e-rowcell" style="text-align: right;">{{data.Importe | number:'1.2-2'}}</td>
                </tr>
              </ng-template>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

        <br/>

        <!-- Personas -->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">supervisor_account</mat-icon> Beneficiarios
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="itemContrato.Personas != null">
            <ejs-grid #gridContratoPersona [dataSource]='itemContrato.Personas' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
              [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
              <e-columns>
                <e-column field='PersonaNombre' headerText='Nombre' width=90></e-column>
                <e-column field='PersonaNroDocumento' headerText='Documento' width=90></e-column>
                <e-column field='PersonaCuit' headerText='CUIT/CUIL' width=90></e-column>
                <e-column field='PersonaMailContacto' headerText='Email' width=90></e-column>
                <e-column field='PersonaMovilContacto' headerText='Nro. Cel.' width=90></e-column>
                <e-column field='Porcentaje' headerText='Porcentaje' width=60 textAlign="right"></e-column>
              </e-columns>
              <ng-template #rowTemplate let-data>
                <tr class="e-row">
                  <td class="e-rowcell" style="text-align: center;">{{data.PersonaNombre}} {{data.PersonaApellido}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.PersonaTipoDocumento}} {{data.PersonaNroDocumento}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.PersonaCuit}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.PersonaMailContacto}}</td>
                  <td class="e-rowcell" style="text-align: center;">{{data.PersonaMovilContacto}}</td>
                  <td class="e-rowcell" style="text-align: right;">{{data.Porcentaje | number:'1.2-2'}}%</td>
                </tr>
              </ng-template>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

      </mat-expansion-panel>

      <!--CUENTA IMPUTADA-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="(item?.CuentaImputadaId > 0)">

        <mat-expansion-panel-header>
          <mat-panel-title class="title"> Datos de Cuenta {{esPagoConCreditoEnCuenta ? 'Crédito' : ''}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container *ngIf="canEdit">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
            <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 10px;">
              <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                  <button mat-raised-button (click)="openDialogCuentaImputadaSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                    <mat-icon style="margin-right: 3px;">search</mat-icon>
                    {{cuentaImputada != null && cuentaImputada.Id > 0 ? 'Cambiar' : 'Asociar'}} {{'Cuenta' | translate}}
                  </button>
                </div>
              <!-- </mat-expansion-panel> -->
            </div>
          </div>

          <br/>

        </ng-container>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="(cuentaImputada != null && cuentaImputada.Id > 0)">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label"><b>Código</b>: {{cuentaImputada.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaImputada.Codigo != null && cuentaImputada.Codigo.length > 0)">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label">
                  <b>Código</b>:
                  <span *ngIf="cuentaImputada.PersonaNombre != null && cuentaImputada.PersonaNombre?.length > 0">{{cuentaImputada.PersonaNombre}}</span>
                  <span *ngIf="cuentaImputada.Proveedor != null && cuentaImputada.Proveedor?.length > 0">{{cuentaImputada.Proveedor}}</span>
                  <span *ngIf="cuentaImputada.Comunidad != null && cuentaImputada.Comunidad?.length > 0">{{cuentaImputada.Comunidad}}</span>
                  <span *ngIf="cuentaImputada.Consorcio != null && cuentaImputada.Consorcio?.length > 0">{{cuentaImputada.Consorcio}}</span>
                  <span *ngIf="cuentaImputada.UnidadFuncional != null && cuentaImputada.UnidadFuncional?.length > 0">{{cuentaImputada.UnidadFuncional}}</span>
                </mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label"><b>Identificador</b>: {{cuentaImputada.ClaveBancaria != null && cuentaImputada.ClaveBancaria.length > 0 ? cuentaImputada.ClaveBancaria : 'Efectivo'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <ng-container *ngIf="cuentaImputada.Id > 0 && !cuentaImputada.EsCuentaCorrienteInterna">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Alias</b>: {{cuentaImputada.Alias}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Banco</b>: {{cuentaImputada.BancoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaImputada.NumeroCuenta}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Titular</b>: {{cuentaImputada.Titular}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </ng-container>

        </div>

      </mat-expansion-panel>

      <!--CUENTA DETALLE-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="!isRosbaco">

        <mat-expansion-panel-header>
          <mat-panel-title class="title"> {{(item?.TipoMovimientoSigno > 0) ? 'Origen del Pago' : 'Destino de los Fondos'}}
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-container *ngIf="canEdit">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">
            <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="margin-top: 10px;">
              <!-- <mat-expansion-panel [expanded]="true" hideToggle="true"> -->
                <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
                  <button mat-raised-button (click)="openDialogCuentaDetalleSearch()" [disabled]="isProcessing()" color="primary" class="zb-button">
                    <mat-icon style="margin-right: 3px;">search</mat-icon>
                    {{cuentaDetalle != null ? 'Cambiar' : 'Asociar'}} {{'Cuenta' | translate}}
                  </button>
                </div>
              <!-- </mat-expansion-panel> -->
            </div>
          </div>

          <br/>

        </ng-container>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="cuentaDetalle == null">
          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label"><b>No hay ninguna cuenta asociada.</b></mat-label>
              </div>
            </mat-expansion-panel>
          </div>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="cuentaDetalle != null">

          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="cuentaDetalle.Codigo != null && cuentaDetalle.Codigo.length > 0">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label"><b>Código</b>: {{cuentaDetalle.Codigo}}</mat-label>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel [expanded]="true" hideToggle="true" *ngIf="!(cuentaDetalle.Codigo != null && cuentaDetalle.Codigo.length > 0)">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label">
                  <b>Código</b>:
                  <span *ngIf="cuentaDetalle.PersonaNombre != null && cuentaDetalle.PersonaNombre?.length > 0">{{cuentaDetalle.PersonaNombre}}</span>
                  <span *ngIf="cuentaDetalle.Proveedor != null && cuentaDetalle.Proveedor?.length > 0">{{cuentaDetalle.Proveedor}}</span>
                  <span *ngIf="cuentaDetalle.Comunidad != null && cuentaDetalle.Comunidad?.length > 0">{{cuentaDetalle.Comunidad}}</span>
                  <span *ngIf="cuentaDetalle.Consorcio != null && cuentaDetalle.Consorcio?.length > 0">{{cuentaDetalle.Consorcio}}</span>
                  <span *ngIf="cuentaDetalle.UnidadFuncional != null && cuentaDetalle.UnidadFuncional?.length > 0">{{cuentaDetalle.UnidadFuncional}}</span>
                </mat-label>
              </div>
            </mat-expansion-panel>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item">
            <mat-expansion-panel [expanded]="true" hideToggle="true">
              <div fxLayout="row stretch" fxLayout.xs="column">
                <mat-label class="text-label"><b>Identificador</b>: {{cuentaDetalle.ClaveBancaria != null && cuentaDetalle.ClaveBancaria.length > 0 ? cuentaDetalle.ClaveBancaria : 'Efectivo'}}</mat-label>
              </div>
            </mat-expansion-panel>
          </div>

          <ng-container *ngIf="cuentaDetalle.Id > 0 && !cuentaDetalle.EsCuentaCorrienteInterna">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Alias</b>: {{cuentaDetalle.Alias}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Banco</b>: {{cuentaDetalle.BancoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Número de Cuenta</b>: {{cuentaDetalle.NumeroCuenta}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-label"><b>Titular</b>: {{cuentaDetalle.Titular}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </ng-container>

        </div>

      </mat-expansion-panel>

      <!--PAGOS-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="!(item.TipoMovimientoSigno > 0) && !isRosbaco">

        <mat-expansion-panel-header>
          <mat-panel-title class="title">
            Pagos Asociados
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isPagosSearching">
          <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isPagosSearching">
          <ejs-grid #pagosGrid [dataSource]='pagosList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
            [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=70 type='date' format="dd/MM/yyyy">
                <ng-template #template let-data>
                  {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                </ng-template>
              </e-column>
              <e-column field='TipoMovimientoNombre' headerText='Tipo' width=80></e-column>
              <e-column field='Detalle' headerText='Detalle' width=110></e-column>
              <e-column field='Estado' headerText='Estado' width=70>
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: getGridEstadoBackgroundColor(data) }">{{data.Estado}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='MedioPagoNombre' headerText='Medio de Pago' width=80></e-column>
              <e-column field='Monto' headerText='Monto Total' width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='Saldo' headerText='Saldo Abonado' width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Saldo * (data.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='SaldoConvertido' headerText='Abonado Original' width=70>
                <ng-template #template let-data>
                  {{data.MonedaConversion}} {{data.SaldoConvertido * (data.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=50>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="viewMovimiento(data.Id)"><i class="fa fa-eye fa-1x"></i></a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>

      </mat-expansion-panel>

      <!--DEUDAS-->
      <mat-expansion-panel [expanded]="true" style="margin-bottom: 1%;" *ngIf="(item?.TipoMovimientoSigno > 0) && !isRosbaco">

        <mat-expansion-panel-header>
          <mat-panel-title class="title">
            Deudas Saldadas
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isDeudasSearching">
          <mat-label class="text-style"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
        </div>

        <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isDeudasSearching">
          <ejs-grid #deudasGrid #grid [dataSource]='deudasList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
            [pageSettings]='pageSettings' [allowResizing]='true' [contextMenuItems]='contextMenuItems' (contextMenuClick)='contextMenuClick($event)' (contextMenuOpen)='contextMenuOpen($event)'>
            <e-columns>
              <e-column field='FechaMovimiento' headerText='Fecha Movimiento' width=90 type='date' format="dd/MM/yyyy">
                <ng-template #template let-data>
                  {{data.FechaMovimiento | date:'dd/MM/yyyy HH:mm:ss'}}
                </ng-template>
              </e-column>
              <e-column field='CuentaImputada' headerText='Referencia' width=90></e-column>
              <e-column field='TipoMovimientoNombre' headerText='Tipo' width=50></e-column>
              <e-column field='Detalle' headerText='Detalle' width=110></e-column>
              <e-column field='Estado' headerText='Estado' width=70>
                <ng-template #template let-data>
                  <mat-label [ngStyle]="{ color: getGridEstadoBackgroundColor(data) }">{{data.Estado}}</mat-label>
                </ng-template>
              </e-column>
              <e-column field='Monto' headerText='Monto Total' width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Monto | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='Saldo' headerText='Saldo Abonado' width=70>
                <ng-template #template let-data>
                  {{data.Moneda}} {{data.Saldo * (data.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column field='SaldoConvertido' headerText='Abonado Original' width=70>
                <ng-template #template let-data>
                  {{data.MonedaConversion}} {{data.SaldoConvertido * (data.Saldo > 0 ? 1 : -1) | number:'1.2-2'}}
                </ng-template>
              </e-column>
              <e-column headerText='Acciones' width=50 textAlign='Center'>
                <ng-template #template let-data>
                  <a style="cursor: pointer; margin-right: 5px" (click)="viewMovimiento(data.Id)"><i class="fa fa-eye fa-1x"></i></a>
                </ng-template>
              </e-column>
            </e-columns>
          </ejs-grid>
        </div>

      </mat-expansion-panel>

    </div>

  </mat-card-content>

  <mat-card-actions>
    <div class="flex-actions" fxLayout="row stretch" fxLayout.xs="column">
      <ng-container *ngIf="canView">
        <button mat-raised-button color="primary" (click)="onGuardar(false)" *ngIf="(item?.Id > 0) && (canEdit || canChangeState)" [disabled]="isProcessing()" class="zb-button">
          {{ isSaving ? 'Guardando...' : 'Guardar' }}
        </button>
        <button mat-raised-button (click)="onGenerarReciboPago()" *ngIf="(item?.TipoMovimientoSigno > 0)" [disabled]="isProcessing()" class="zb-button">
          {{ isGenerandoRecibo ? 'Imprimiendo...' : 'Imprimir Recibo' }}
        </button>
        <button mat-raised-button (click)="onReject()" *ngIf="(item?.Id > 0) && canCancel && item.PuedeRechazar" [disabled]="isProcessing()" color="primary" class="zb-button" style="margin-left: 5px;">
          {{ isRejecting ? 'Cancelando...' : 'Cancelar Movimiento' }}
        </button>
      </ng-container>
      
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">Cerrar</button>
    </div>
  </mat-card-actions>

</mat-card>
